<template>
  <div class="section__header coso cosito" :class="{bg: playing}">
    <font-awesome-icon :icon="['far', 'play-circle']" class="icon" size="5x" @click="playVid" v-if="!playing"/>
    <font-awesome-icon :icon="['far', 'circle-notch']" class="icon" size="5x" spin v-if="loading && playing"/>
    <div class="vid--container" :class="{invisible: !playing}">
      <div id="content" class="content"/>
    </div>
    <div class="mouse" @click="scrollToContent">
      <scroll v-if="windowWidth > 768" class="scroll"></scroll>
      <swipe v-else></swipe>
    </div>
  </div>
</template>
<script>
import mixins from '@/mixins/mixins'
import VimeoPlayer from '@vimeo/player'
import scroll from '@/assets/scroll.svg'
import swipe from '@/assets/swipe.svg'

export default {
  mixins: [mixins],
  components: {
    scroll,
    swipe
  },
  mounted () {
    let options = {
      id: 333832133,
      muted: true,
      loop: true,
    }
    this.$store.commit('setScrolling', false)
    // this.vPlayer = new VimeoPlayer(document.querySelector('iframe'))
    this.vPlayer = new VimeoPlayer('content', options)
    this.vPlayer.on('play', () => {
      this.loading = false
    })
    this.vPlayer.on('pause', () => {
      this.loading = false
      this.playing = false
    })
    window.addEventListener('mousewheel', event => {
      const delta = Math.sign(event.deltaY)
      this.deltaY = delta
    })
  },
  data () {
    return {
      playing: null,
      loading: true,
      vPlayer: null,
      deltaY: 0
    }
  },
  methods: {
    scrollToContent () {
      this.vPlayer.pause().then(() => {
      }).catch(e => {
      })
      const element = document.querySelector('.nosotros')
      element.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      })
    },
    playVid () {
      this.playing = true
      this.vPlayer.play().then(() => {
      }).catch((e) => {
        throw new Error(e)
      })
      this.vPlayer.setVolume(1).then(() => {
      }).catch((e) => {
        throw new Error(e)
      })
    }
  },
  computed: {
    windowWidth () {
      return this.$store.state.windowWidth
    }
  }
}
</script>
